import { SearchWarehouseForm } from './SearchForm';

export const encodedAndFilterValues = (formValue: Record<string, any>) => {
	return Object.fromEntries(
		Object.entries(formValue)
			.filter(([_, value]) => value !== '' && value !== undefined && value !== null)
			.map(([key, value]) =>
				typeof value === 'string' ? [key, encodeURIComponent(value)] : [key, value],
			), // Кодируем значения
	);
};

export const parseQueryParamsForFindWarehouseFilter = (
	query: Record<string, any>,
): SearchWarehouseForm => {
	return {
		location: query?.location ? decodeURIComponent(query.location) : undefined,
		max_distance: query?.max_distance ? Number(query.max_distance) : undefined,
		temp_regime: query?.temp_regime ? String(query.temp_regime) : undefined,
		free_volume: query?.free_volume ? query.free_volume : undefined,
		loading_unloading_type: query?.loading_unloading_type
			? String(query.loading_unloading_type) === 'true'
			: undefined,
		ref_containers: query?.ref_containers ? query.ref_containers === 'true' : undefined,
		latitude: query?.latitude ? query.latitude : undefined,
		longitude: query?.longitude ? query.longitude : undefined,
		certification_importers: query?.certification_importers
			? decodeURIComponent(query.certification_importers)
			: undefined,
		has_inspection_room: query?.has_inspection_room
			? query.has_inspection_room === 'true'
			: undefined,
		title: query?.title ? decodeURIComponent(query.title) : undefined,
	};
};
